'use client';

import React, { useMemo, memo } from 'react';
import styles from './VerticalMarquee.module.css';

interface VerticalMarqueeProps {
  text: string;
}

const VerticalMarquee: React.FC<VerticalMarqueeProps> = memo(({ text }) => {
  const marqueeItems = useMemo(() => Array(8).fill(text), [text]);

  return (
    <div className={styles.marqueeContainer} aria-hidden="true">
      <div className={styles.marqueeContent}>
        {marqueeItems.map((item, index) => (
          <div className={styles.marqueeItem} key={index}>
            {item}
          </div>
        ))}
        {/* Duplicate for seamless loop */}
        {marqueeItems.map((item, index) => (
          <div className={styles.marqueeItem} key={`duplicate-${index}`}>
            {item}
          </div>
        ))}
      </div>
    </div>
  );
});

VerticalMarquee.displayName = 'VerticalMarquee';

export default VerticalMarquee;
